/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Start_B_TInputs */

const en_wc_start_b_t = /** @type {(inputs: Wc_Start_B_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create or open a document`)
};

/**
* | output |
* | --- |
* | "Create or open a document" |
*
* @param {Wc_Start_B_TInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_start_b_t = /** @type {((inputs?: Wc_Start_B_TInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Start_B_TInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_start_b_t(inputs)
});
export { wc_start_b_t as "wc.start.b_t" }